import { Button, Form, Input, Modal, notification, Popconfirm } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

export default function UpdateProfileModal({
  showUpdateProfileModal,
  setShowUpdateProfileModal,
  updateProfile,
  profileForm,
  businessName,
  userAddress,
  requestLocation,
  buttonLoading,
  deleteAccount
}) {
  return (
    <Modal
      visible={showUpdateProfileModal}
      onCancel={() => setShowUpdateProfileModal(false)}
      footer={null}
      title="Update Profile"
    >
      <Form
        form={profileForm}
        onFinish={updateProfile}
        layout="vertical"
        initialValues={{
          businessName: businessName || "",
          mobileNumber: "",
          email: "",
        }}
      >
        <Form.Item
          label="Business Name"
          name="businessName"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Mobile Number"
          name="mobileNumber"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, type: "email" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="Current address" name="currentAddress">
          <Input.TextArea
            defaultValue={userAddress}
            disabled
            autoSize={{ minRows: 2 }}
          />
        </Form.Item>
        <div>
          <Button
            type="dashed"
            icon={<EnvironmentOutlined />}
            onClick={() => requestLocation(false, true)}
            style={{ width: "100%", marginBottom: "16px" }}
          >
            Use current location
          </Button>
        </div>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px'
        }}>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={buttonLoading}
            style={{ flex: 1 }}
          >
            Update Profile
          </Button>
          <Popconfirm
            title="Delete Account"
            description="Are you sure you want to delete your account?"
            okText="Yes, Delete"
            cancelText="No"
            okButtonProps={{ danger: true }}
            onConfirm={deleteAccount}
          >
            <Button 
              danger
              style={{ 
                flex: 1,
                backgroundColor: '#ff4d4f',
                color: 'white',
                borderColor: '#ff4d4f',
              }}
            >
              Delete Account
            </Button>
          </Popconfirm>
        </div>
      </Form>
    </Modal>
  );
}
